<template>
  <div class="page-content">
    <div class="content-wrapper">
      <SidebarFilters
        :isSearching="isLoadingData"
        :inputsAvaliables="['accessTypes']"
        @search="search"
      />
      <div class="card">
        <div class="card-header d-flex align-items-center py-0">
          <h4 class="py-3 mb-0">Relatório de Aderência</h4>
        </div>
        <div class="card-body">
          <div id="no-content" v-if="data == null && isLoadingData == false">
            <h6 class="text-center mb-0">
              Selecione um filtro e clique em buscar
            </h6>
          </div>
          <LoadingData v-else-if="isLoadingData" />
          <div v-else>
            <div class="row">
              <div class="col-12 col-md-6">
                <ChartGrip :data="data" />
              </div>
              <div class="col-12 col-md-6">
                <table class="table table-striped table-hover table-bordered">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th class="text-center">Quantidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, key) in data.dataSeries" :key="key">
                      <td>{{ item.name }}</td>
                      <td class="text-center">{{ item.value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12">
                <h5>Detalhes:</h5>
                <DetailsGrip :data="data" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import SidebarFilters from '@/components/reports/globals/SidebarFilters.vue'
import ChartGrip from '@/components/reports/grip/ChartGrip.vue'
import DetailsGrip from '@/components/reports/grip/DetailsGrip.vue'

export default {
  name: 'ReportGrip',

  components: {
    LoadingData,
    SidebarFilters,
    ChartGrip,
    DetailsGrip,
  },

  data() {
    return {
      filters: {
        sendStartDate: null,
        sendEndDate: null,
      },
      data: null,
      isLoadingData: false,
    }
  },

  methods: {
    search(filters) {
      this.filters = filters
      this.searchGripReport()
    },

    async searchGripReport() {
      try {
        this.isLoadingData = true
        // Retira dos filtros os campos que estão vazios
        Object.keys(this.filters).forEach(
          (key) => this.filters[key] == null && delete this.filters[key],
        )
        this.data = await this.$store.dispatch('searchGripReport', this.filters)
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
}
</script>
